<template>
    <div class="card card-small" v-if="fetched">
        <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0 responsive-table">
                <thead class="bg-light">
                <tr>
                    <th scope="col" class="border-0">Data kontaktu</th>
                    <th scope="col" class="border-0">Rodzaj kontaktu</th>
                    <th scope="col" class="border-0">Notka</th>
                    <th scope="col" class="border-0">Koszty dodatkowe</th>
                    <th scope="col" class="border-0">Kwota wpłaty</th>
                    <th scope="col" class="border-0">Data wpłaty</th>
                    <th scope="col" class="border-0">Pliki</th>
                    <th scope="col" class="border-0" style="width: 210px;">Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(contact, index) in history" :key="contact.id">
                    <td>
                        <dt>ID</dt>
                        <dd>{{ contact.created_at }}</dd>
                    </td>
                    <td>
                        <dt>Rodzaj kontaktu</dt>
                        <dd>{{ contactFromType(contact.type) }}</dd>
                    </td>
                    <td>
                        <dt>Notka</dt>
                        <dd><span class="contact-note">{{ contact.description }}</span></dd>
                    </td>
                    <td>
                        <dt>Koszty dodatkowe</dt>
                        <dd v-if="contact.is_costs == '1'">{{ toNumber(contact.costs) }} zł</dd>
                        <dd v-else>Brak</dd>
                    </td>
                    <td>
                        <dt>Kwota wpłaty</dt>
                        <dd v-if="contact.is_costs == '1'" :class="{ 'text-success' : (contact.amount_paid && contact.costs === contact.amount_paid ) }">{{ contact.amount_paid ? toNumber(contact.amount_paid) + ' zł' : '0,00 zł' }}</dd>
                        <dd v-else>-</dd>
                    </td>
                    <td>
                        <dt>Data wpłaty</dt>
                        <dd v-if="contact.is_costs == 1 && contact.payment_date">{{ contact.payment_date }}</dd>
                        <dd v-else>-</dd>
                    </td>
                    <td>
                        <dt>Pliki</dt>
                        <dd>
                            <div  v-if="contact.files.length > 0" >
                                <a href="#"@click.prevent="downloadFile(contact.files[0])">{{contact.files[0].filename}}</a> <span v-if="contact.files.length > 1"> ({{(contact.files.length - 1)}} więcej)</span>
                                <div class="clearboth"></div>
                            </div>
                        </dd>
                    </td>
                    <td>
                        <dt>Akcje</dt>
                        <dd>
                            <d-button
                                @click.prevent="editContact(contact)"
                                class="my-1 mr-3">
                                <i class="material-icons">edit</i> Edytuj
                            </d-button>
                            <d-button
                                v-if="!finished"
                                theme="danger"
                                class="my-1"
                                @click.prevent="removeContact(contact)">
                                <i class="material-icons">delete</i> Usuń
                            </d-button>
                        </dd>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="history.length < 1" class="text-info">Brak kontaktów do wyświetlenia.</p>
        </div>
    </div>
</template>

<script>
    import FileSaver from 'file-saver'

    export default {
        name: 'ContactsHistory',
        props: {
            props: {
                type: Array,
                default: ()=>[]
            },
            finished: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return{
                history: [],
                fetched: true
            }
        },
        methods: {
            editContact(contact){
                contact.files_to_delete = [];
                this.$emit('editContact', _.clone(contact))
            },
            toNumber(number){
                return Vue.toNumber(number);
            },
            contactFromType(type){
                switch (type){
                    case 'phone':
                        return 'Telefon';
                        break;
                    case 'email':
                        return 'E-mail';
                        break;
                    case 'post':
                        return 'Poczta';
                        break;
                }
            },
            downloadFile(doc){
                axios.post('api/contact-history/download-client-history-file',
                    {id: doc.id,},
                    {responseType: 'blob'}
                    ).then(response => {
                    let blob = new File([response.data], doc.filename );
                    FileSaver.saveAs(blob);
                }).catch((error)=>{
                    Vue.swal({
                        title: 'Nie udało się pobrać pliku',
                        text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
                        type: 'error',
                    });
                });
            },
            removeContact(contact){
                Vue.swal({
                    title: 'Uwaga',
                    html: 'Czy potwierdzasz usunięcie kontaktu?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Tak',
                    cancelButtonText: 'Nie',
                    buttonsStyling: true
                }).then((logout) => {
                    if(logout.value){
                        axios.post('api/contact-history/remove-client-history', {
                            id: contact.id
                        }).then(response => {
                            this.$emit('removeContact', contact.id);
                            Vue.swal({
                                type: 'success',
                                title: 'Kontakt został usunięty.',
                                showConfirmButton: true,
                            });
                        }).catch((errors) =>{
                            console.log(errors);
                        })
                    }
                }).catch((errors) =>{
                    console.log(errors);
                })
            }
        },
        mounted(){
            this.history = this.props ? this.props : this.history;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.history = to;
                },
                deep: true
            }
        }
    }
</script>

<style>
    .contact-note{
        min-width: 150px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        white-space: nowrap;
    }
</style>
